module.exports = __webpack_public_path__ + "img/sentry.fab93116.png";